var map = {
	"./flag_1.png": 16186,
	"./flag_2.png": 40849,
	"./flag_3.png": 84552,
	"./flag_4.png": 76071,
	"./flag_5.png": 88382,
	"./flag_6.png": 74133,
	"./flag_7.png": 7596
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47942;